import { IsString, IsUUID } from 'class-validator';

export class CreateChatMessageReactionDto {
	@IsUUID()
	chat_message_id: string;

	@IsUUID()
	target_id: string;

	@IsString()
	emoji: string;
}
